import { Href } from '@weenat/client/dist/routx/runtime-core'
import { useNavigate } from 'app/routx-router'
import { PREVENT_DRAG_CLASSNAME } from 'app/src/dashboard/components/plots/dashboards/constants'
import { ReactNode } from 'react'
import DelimitedFlex from '../DelimitedFlex'
import Icons from '../Icons'
import Text from '../Text'
import WeenatPressable, { WeenatPressableProps } from '../WeenatPressable'

interface FooterProps extends Omit<WeenatPressableProps, 'onPress' | 'className'> {
  destination: string | number | (() => void)
  label: string
  icon?: ReactNode
}

const padding = { borderTopLeftRadius: 0, borderTopRightRadius: 0 }

const WeedgetFooter: FC<FooterProps> = ({
  destination,
  label,
  icon = <Icons.ArrowRight $size='md' />,
  ...pressableProps
}) => {
  const nav = useNavigate()
  return (
    <WeenatPressable
      {...pressableProps}
      onPress={typeof destination === 'function' ? destination : () => nav(destination as Href)}
      targetFirstChild
      className={PREVENT_DRAG_CLASSNAME}
    >
      <DelimitedFlex
        $isDelimitedOnTop
        $p='md'
        $alignItems='center'
        $justifyContent='center'
        $gap='md'
        $borderRadius='lg'
        style={padding}
        $backgroundColor='grayscale.white'
        $maxHeight={32}
      >
        <Text $fontWeight='bold'>{label}</Text>
        {icon}
      </DelimitedFlex>
    </WeenatPressable>
  )
}

export default WeedgetFooter
